/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { AuthGuard } from './services/auth.guard.service';
import { TokenInterceptor } from './services/token-interceptor.service';
import { NbAuthModule, NbPasswordAuthStrategy } from '@nebular/auth';
import { domain } from './app.constants';
import { NbDateFnsDateModule } from '@nebular/date-fns';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbDateFnsDateModule.forRoot({ format: 'dd.MM.yyyy' }),
    NbChatModule.forRoot({
      // messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'auth',
          token: {
            key: 'token',
          },
          login: {
            endpoint: '/login',
            method: 'post',
            requireValidToken: false,
            redirect: {
              success: '/profile/me',
              failure: null, // stay on the same page
            },
          },
          register: {
            endpoint: '/register',
            method: 'post',
            requireValidToken: false,
            redirect: {
              success: null,
              failure: null, // stay on the same page
            },
          },
          logout: {
            endpoint: '/logout',
            method: 'post',
            requireValidToken: false,
            redirect: {
              success: '/auth/login',
              failure: null, // stay on the same page
            },
          },
          baseEndpoint: domain,
        })
      ],
      forms: {
        login: {
          strategy: 'auth',
        },
        register: {
          strategy: 'auth'
        },
        logout: {
          strategy: 'auth'
        }
      },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ]
})
export class AppModule {
}
